import { render, staticRenderFns } from "./BeWrapperBasketPackage.vue?vue&type=template&id=0508bc0a&scoped=true"
import script from "./BeWrapperBasketPackage.vue?vue&type=script&lang=js"
export * from "./BeWrapperBasketPackage.vue?vue&type=script&lang=js"
import style0 from "./BeWrapperBasketPackage.vue?vue&type=style&index=0&id=0508bc0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508bc0a",
  null
  
)

export default component.exports